/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCopyFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCopyFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCopyFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCopyFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 12"
 style={{'--as-1-1B8Uh7': alignSelf,'--mt-2-1B8Uh7': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1B8Uh7': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1B8Uh7': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1B8Uh7': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1B8Uh7': opacity,'--w-10-1B8Uh7': typeof width === 'number' ? `${width}px` : width,'--h-11-1B8Uh7': typeof height === 'number' ? `${height}px` : height,'--f-12-1B8Uh7': fill,'--a-7-1B8Uh7': isAnimated ? animation : "none",'--sd-8-1B8Uh7': isAnimated ? strokeDashoffset : 0,'--sd-9-1B8Uh7': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCopyFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.286 1.5c0-.118.096-.214.214-.214h4.286a.643.643 0 100-1.286H1.5A1.5 1.5 0 000 1.5v6.643a.643.643 0 001.286 0V1.5zM4.07 2.571h2.465v3c0 .296.24.536.535.536h3v4.607c0 .71-.575 1.286-1.285 1.286H4.07c-.71 0-1.285-.576-1.285-1.286V3.857c0-.71.575-1.286 1.285-1.286zm3.536.108l2.357 2.357H7.607V2.679z"
 style={{'--f-12-1B8Uh7': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}